import React, {useEffect, useState} from "react";
import {Icon, IconButton, InputAdornment, TextField} from "@material-ui/core";
import JsonScreenHoc from "../../../../HocHelpers/JsonScreenHoc";
import {useDispatch} from "react-redux";
import {setStringFilter} from "../../jsonScreen.slice";
import {useHistory} from "react-router";

const iconPositions = {
    'start': 'startAdornment',
    'end': 'endAdornment'
};
const SearchBarComponent = (props) => {
    const {component: {properties = {}, styles: sourceStyles}} = props;
    const dispatch = useDispatch();
    const [searchValue, setSearchValue] = useState('');
    const history = useHistory();

    const {iconPosition = 'end', ...styles} = sourceStyles ? sourceStyles[0] : {};
    const {list} = properties;

    function setQuickSearch() {
        dispatch(setStringFilter({[list]: searchValue}))
    }

    useEffect(() => {
        return () => {
            dispatch(setStringFilter({}))
        }

    }, [])

    useEffect(() => {
        const {location: {state: {prevListState = {}} = {}} = {}} = history;
        if (prevListState && prevListState[list]) {
            setSearchValue(prevListState[list].searchValue)
        }
    }, [])

    return (
        <div style={{
            width: styles.width,
            padding: styles.padding,
            margin: styles.margin
        }}
             className={"sb_searchbar_container"}
        >
            <TextField
                size={"small"}
                className={"sb_searchbar_input"}
                variant={styles.variant || "outlined"}
                onKeyDown={e => {
                    if (e.key === 'Enter') {
                        setQuickSearch()
                    }
                }}
                placeholder={'Search...'}
                fullWidth
                value={searchValue}
                onChange={e => setSearchValue(e.target.value)}
                InputProps={{
                    [iconPositions[iconPosition]]: (<InputAdornment position={iconPosition}>
                        <IconButton onClick={setQuickSearch} size={"small"} className={"sb_searchbar_input_icon"}>
                            <Icon fontSize={"default"}>
                                search
                            </Icon>
                        </IconButton>
                    </InputAdornment>)
                }}
            />
        </div>
    )
}
export default JsonScreenHoc(SearchBarComponent)